// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.section[data-v-1952271e] {\n    border-top: 3px solid #037397;\n    margin: 2em 0;\n}\n.section-header[data-v-1952271e] {\n    margin: .5em 0;\n}\n.section-content[data-v-1952271e] {\n}\n.invalid-feedback[data-v-1952271e] {\n    margin-top: 1px;\n    margin-left: 1px;\n    color: #D63301;\n}\n", ""]);
// Exports
module.exports = exports;
